import { useEffect, useState } from "react";

const CHAPTERS = [
  { id: "hero", n: "00" },
  { id: "incident", n: "01" },
  { id: "evidence", n: "02" },
  { id: "witness", n: "03" },
  { id: "instrumentation", n: "04" },
  { id: "hypotheses", n: "05" },
  { id: "rootcause", n: "06" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: 0 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function ChapterRail() {
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    CHAPTERS.forEach((c) => {
      const el = document.getElementById(c.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-[75] hidden lg:flex flex-col gap-4 items-end">
      {CHAPTERS.map((c) => {
        const on = active === c.id;
        return (
          <button
            key={c.id}
            data-testid={`rail-${c.id}`}
            onClick={() => scrollTo(c.id)}
            className="group flex items-center gap-3"
          >
            <span
              className={`font-mono-data text-[10px] tracking-widest transition-all duration-300 ${
                on ? "text-[#b88457] opacity-100" : "text-zinc-600 opacity-0 group-hover:opacity-100"
              }`}
            >
              {c.n}
            </span>
            <span
              className={`h-px transition-all duration-500 ${
                on ? "w-8 bg-[#b88457]" : "w-4 bg-zinc-700 group-hover:bg-zinc-400"
              }`}
            />
          </button>
        );
      })}
    </div>
  );
}
